import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { ConfirmationService, Table } from 'primeng';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-manage-shift-planning',
  templateUrl: './manage-shift-planning.component.html',
  styleUrls: ['./manage-shift-planning.component.scss'],
})
export class ManageShiftPlanningComponent implements OnInit {
  @ViewChild('dt') dataTable: Table;
  // @ViewChild('op') op: OverlayPanel;
  endsOnTableList = AppSettings.SHIFT_PLANNING_ENDSON_TABLELIST;
  endsOnFilterTableList = AppSettings.SHIFT_PLANNING_ENDSON_FILTERLIST;
  @Output() selectedAddDataEmmiter: EventEmitter<any> = new EventEmitter<any>();
  labelAddShift = 'Add New Shift';
  labelOverride = 'Override';
  labelAdjust = 'Adjust';
  labelCancel = 'Cancel';
  labelSave = 'Save';
  tableData: any = [];
  showDatePicker = false;
  rows: any = [];
  shiftAllData: any = [];
  labelYes: any;
  labelNo: any;
  minDate: Date;
  maxDate: Date;
  dateFormat;
  teamList: any[] = [];
  formRequiredStatus = false;
  daysList = AppSettings.SHIFT_PLANNING_DAYS_LIST;
  shiftButtonDisabled = false;
  showDialog = false;
  allocationListStr: any;
  shiftScheduleValue: any;
  shiftStartTime: any;
  shiftEndTime: any;
  teamListIds: any = [];
  startDateTimeStr: any;
  endDateTimeStr: any;
  provider: any;
  teamName: any;
  currentRowSelectedId: any;
  hideFilterSection = false;
  searchData = '';
  endsonFilter: any;
  groupLimit = 100;
  groupOffset = 0;
  totalRecords: any;
  teamMembers: any = [];
  providerList: any = [];
  noofRows: any;
  products: any = [];
  clonedProducts: any = [];
  minuteArray: number[] = [0, 15, 30, 45];
  currentDate = new Date();
  availableStartTime: Date;
  availableEndTime: Date;
  currentPermanentMembers: any = [];
  isEditEnable = false;
  loginTypeList: any;
  loginTypeisWeb = false;
  getUsersList: any = [];
  loginTypes: number;
  userScheduleId: any[] = [];
  userList: any[] = [];
  shiftPlanUsers: any = [];
  userType: any;
  loginUserId: any;
  userInfo: any;
  filterSavedFlag: Boolean = false;
  filterLocalData: any;
  FilterDataFlag: any;
  showteamMembers = false;
  updateType: any;
  selectedRowData: any;
  dt: any;
  isBulkScheduleDisabled: any;
  searchTerm = '';
  filteredTeamMembersList: any[] = [];
  disableDates = false;
  checkStartTime: any;
  chosenTeam = '';
  selectedLabel = '';
  providerListFilter = [];
  providerIdForFilter = '';
  serviceRegionList: any[] = [];
  selectedServiceRegionIds: any[] = [];
  disableProvider = false;
  showCustomDatePicker = false;
  customDate;
  endsonFilterValue = '';

  globalConfigMSFWPU = false;
  organizationLevelDispatch = false;
  filterdUserList = [];


  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private router: Router,
    private uiService: UiService,
    private storageService: StorageService,
    private commonService: CommonBindingDataService,
  ) { }

  ngOnInit(): void {
    this.globalConfigMSFWPU = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.MANAGE_SHIFT)?.value;
    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userInfo) {
      this.loginUserId = this.userInfo.id;
    }
    this.applyProviderRoleScope();
    this.loadServiceRegions();
    this.getProvider();
    this.getLabelAndDate();
    this.loadShiftPlanningList();
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    try {
      if (tagsData === null) {
        const localTagData = localStorage.getItem('localTagdata');
        this.getLoginTypes(localTagData ? JSON.parse(localTagData) : null);
      } else {
        this.getLoginTypes(tagsData);
      }
    } catch (e) {
      this.userList = [{ label: this.commonBindingDataService.getLabel('Select'), value: '' }];
    }


    // this.getTeam();
    this.teamList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
    this.getUsersListData();

    // this.getTeamMembers();
    this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();


    setTimeout(() => {
      this.getFilter();
    }, 1000);
    const filterObj: any = this.storageService.getItem(AppSettings.FILTER_DETAILS_PANNING);
    this.filterLocalData = filterObj;
    const savedFilterLocal = localStorage.getItem('shiftPlanningFilterPresent');
    let localData = null;
    if (savedFilterLocal) {
      try {
        localData = JSON.parse(savedFilterLocal);
      } catch (e) {
        localStorage.removeItem('shiftPlanningFilterPresent');
      }
    }
    if (localData) {
      this.filterLocalData = localData.filterData;
    }
    if (filterObj || localData) {
      this.getFilterLocal(this.filterLocalData);
    }
  }

  private processShiftPlanListData(results: any) {
    this.totalRecords = results?.count || 0;
    const rows = results?.data || [];
    this.shiftAllData = rows;
    this.products = rows;
    for (let i = 0; i < this.shiftAllData.length; i++) {
      const text = this.shiftAllData[i].allocations || '';
      Object.assign(this.shiftAllData[i], {
        'weeklyAllocation': [
          { key: '1', displayValue: 'S', isMandatory: text.includes('1') },
          { key: '2', displayValue: 'M', isMandatory: text.includes('2') },
          { key: '3', displayValue: 'T', isMandatory: text.includes('3') },
          { key: '4', displayValue: 'W', isMandatory: text.includes('4') },
          { key: '5', displayValue: 'T', isMandatory: text.includes('5') },
          { key: '6', displayValue: 'F', isMandatory: text.includes('6') },
          { key: '7', displayValue: 'S', isMandatory: text.includes('7') }
        ]
      });
      const teamListAllId = [];
      const teamList = this.shiftAllData[i].teamList || [];
      for (let j = 0; j < teamList.length; j++) {
        teamListAllId.push(teamList[j].teamId);
      }
      Object.assign(this.shiftAllData[i], { 'selectedTeamList': teamListAllId });
      if (this.isEditEnable) {
        this.isEditEnable = false;
        this.shiftButtonDisabled = false;
      }
    }
  }

  getLabelAndDate() {
    this.labelYes = this.commonBindingDataService.getLabel('label_yes');
    this.labelNo = this.commonBindingDataService.getLabel('label_no_without_dot');
    this.labelAddShift = 'Add New Shift';
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.maxDate = new Date(this.minDate);
  }

  getProvider() {
    // this.providerList.push({ label: this.commonBindingDataService.getLabel('All'), value: '' });
    if (!this.disableProvider) {
    this.manageOpenShiftsService.getProvider().subscribe(results => {
      if (this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.value) {
        this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.forEach(e => {
          results = results.filter(ele => ele.id !== e.providerId);
        });
      }
      const providerData = results;
      this.providerList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
      for (let i = 0; i < providerData.length; i++) {
        if (providerData[i].providerName !== null) {
          this.providerList.push({ label: providerData[i].providerName, value: providerData[i].id });
        }
      }

      this.providerListFilter.push({ label: this.commonBindingDataService.getLabel('All'), value: '' });
      for (let i = 0; i < providerData.length; i++) {
        if (providerData[i].providerName !== null) {
          this.providerListFilter.push({ label: providerData[i].providerName, value: providerData[i].id });
        }
      }
      this.provider = '';
      this.providerIdForFilter = '';

    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
    } else {
      this.manageOpenShiftsService.getProvider().subscribe(results => {
      const providerData = results;
      const providerName = providerData.find(item => item.id === this.loginUserId);

      this.providerList.push({ label: providerName.providerName, value: providerName.id });
      this.provider = providerName.id;

      this.getTeam(providerName.id);

      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });
    }
  }

  onTeamSelect(data, event) {
    if (this.disableProvider) {
        data.userType = '';
    }
    this.teamMembers = [];
    this.filteredTeamMembersList = [];
    this.searchTerm = '';
    this.shiftPlanUsers = [];
    if (event.value !== '') {
      // item.endDateTimeStr = '';
      this.uncheckAllMobileMembers();
      this.getTeamMembers(event.value);
      this.selectedLabel = this.teamList.find(item => item.value === event?.value)?.label;
      if (this.disableProvider) {
        setTimeout(() => {
          data.userType = '10';
        }, 1000);
      }
      // this.chosenTeam = this.provider
    } else {
      this.showteamMembers = false;
      this.chosenTeam = '';
    }
  }

  getTeamMembers(teamId) {
    this.manageOpenShiftsService.getTeamMember(teamId).subscribe(results => {
      if (results.length > 0) {
      this.showteamMembers = true;
      this.teamMembers = results;
      this.chosenTeam = this.provider;
      this.applyTeamMemberFilter();
      } else {
        this.showteamMembers = true;
        this.chosenTeam = this.provider;
        this.filteredTeamMembersList = [];
        // this.chosenTeam = '';
      }

    });
  }

  updateShiftPlanUsers(member: any) {
    if (member.selected) {
        this.shiftPlanUsers.push({ userId: member.userId });
    } else {
        this.shiftPlanUsers = this.shiftPlanUsers.filter(user => user.userId !== member.userId);
    }
  }

  updateShiftPlanUsersWeb(member: any) {
    if (member.selected) {
        this.shiftPlanUsers.push({ userId: member.value });
    } else {
        this.shiftPlanUsers = this.shiftPlanUsers.filter(user => user.userId !== member.value);
    }
  }

  hideFilter(event) {
    this.hideFilterSection = event === true ? true : false;
  }

  applyFilter(event) {
    if (event.value === '') {
      this.getShiftData();
    } else {
      this.getFilterdData();
    }
  }

  loadServiceRegions(savedRegionIds?: any[], refresh = false) {
    const regions$ = this.providerIdForFilter
      ? this.commonService.getServiceRegionsByProviderID(this.providerIdForFilter)
      : this.commonService.getServiceRegions();

    regions$.subscribe((regions) => {
      this.serviceRegionList = this.commonService.mapServiceRegionOptions(regions);
      if (savedRegionIds && savedRegionIds.length) {
        this.selectedServiceRegionIds = savedRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      } else if (this.selectedServiceRegionIds.length) {
        this.selectedServiceRegionIds = this.selectedServiceRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      }
      if (refresh) {
        if (!this.providerIdForFilter && !this.selectedServiceRegionIds?.length) {
          this.getShiftData();
        } else {
          this.getFilterdData();
        }
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onProviderChange() {
    this.loadServiceRegions(undefined, true);
  }

  onServiceRegionChange() {
    this.getFilterdData();
  }

  applySearchFilter() {
    this.getFilterdData();
  }

  loadShiftPlanningList() {
    this.disableProvider ? this.getFilterdData() : this.getShiftData();
  }

  getFilterdData() {
    this.manageOpenShiftsService.getFilteredShiftPlanningData(
      this.groupLimit, this.groupOffset, this.providerIdForFilter, this.endsonFilterValue, this.searchData,
      this.selectedServiceRegionIds
    ).subscribe(results => {
      this.groupLimit = 100;
      this.processShiftPlanListData(results);
    }, (error) => {
    this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getShiftData() {
    this.manageOpenShiftsService.getShiftPlanningData(this.groupLimit, this.groupOffset).subscribe(results => {
      this.groupLimit = results?.count || this.groupLimit;
      this.processShiftPlanListData(results);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  endsOnCustomDate(item, event) {
    if (event.value === 'custom') {
      item.endDateTimeStr = '';
      this.disableDates = false;
    } else {
      this.disableDates = true;
    }
  }
  onShiftProviderChange(event) {
    this.provider = event.value;
    this.teamList = [];
    this.teamList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
    this.getTeam(this.provider);
    this.chosenTeam = '';
    this.showteamMembers = false;
  }

  newRow() {
    return {
      weeklyAllocation: [
        { key: '1', displayValue: 'S', isMandatory: false },
        { key: '2', displayValue: 'M', isMandatory: false },
        { key: '3', displayValue: 'T', isMandatory: false },
        { key: '4', displayValue: 'W', isMandatory: false },
        { key: '5', displayValue: 'T', isMandatory: false },
        { key: '6', displayValue: 'F', isMandatory: false },
        { key: '7', displayValue: 'S', isMandatory: false }
      ],
      spPermenantMembers: [], shiftSchedule: '', startTimeStr: '', endTimeStr: '', endDate: '', teamList: ''
    };
  }

  onRowEditInit(selectedEditData) {
   // this.addBulkEnabled = true;
    this.isEditEnable = true;
    this.showteamMembers = true;
    this.clonedProducts[selectedEditData.id] = { ...selectedEditData };
    // dt.editingRowKeys = { [selectedEditData.id]: true }
    if (selectedEditData.endDate === '-1') {
      selectedEditData.endDate = 'never';
    } else {
      selectedEditData.endDate = 'custom';
    }
    this.currentRowSelectedId = selectedEditData.id;
    this.shiftButtonDisabled = true;
    const userTypeId = selectedEditData.userType;
    setTimeout(() => {
      this.loginTypeisWeb = userTypeId === '20' ? true : false;
    }, 100);
    if (userTypeId === '10') {
        this.getTeamMembers(selectedEditData.teamList[0].teamId);
    }
    if ((selectedEditData.selectedTeamList && selectedEditData.selectedTeamList.length > 0)
      && (this.teamList && this.teamList.length > 0)) {
      for (let i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].value === selectedEditData.selectedTeamList[0]) {
          selectedEditData.selectedTeamList = (this.teamList[i].value);
        }
      }

      for (let i = 0; i < this.providerList.length; i++) {
        if (this.providerList[i].value === selectedEditData.providerId) {
          selectedEditData.provider = this.providerList[i].value;
          this.provider = this.providerList[i].value;
        }
      }

    }

    if (selectedEditData.shiftPlanUsers && selectedEditData.shiftPlanUsers.length > 0
      && this.getUsersList && this.getUsersList.length > 0) {
      const matchedUsers = [];
      for (let j = 0; j < selectedEditData.shiftPlanUsers.length; j++) {
        for (let i = 0; i < this.getUsersList.length; i++) {
          if (this.getUsersList[i].value === selectedEditData.shiftPlanUsers[j].userId) {
            matchedUsers.push(this.getUsersList[i].value);
          }
        }
      }
      this.updateMemberSelection(matchedUsers);
      selectedEditData.shiftPlanUsers = matchedUsers;
    }
    setTimeout(() => {
    if (selectedEditData.spPermanentMembers && selectedEditData.spPermanentMembers.length > 0
      && this.teamMembers && this.teamMembers.length > 0) {
        const matchedUsers = [];
        for (let j = 0; j < selectedEditData.spPermanentMembers.length; j++) {
         matchedUsers.push(selectedEditData.spPermanentMembers[j].userId);
        }
        this.updateMobileMemberSelection(matchedUsers);
    }
    }, 1000);

  }

  updateMemberSelection(matchedUsers) {
    for (let i = 0; i < this.getUsersList.length; i++) {
      for (let j = 0; j < matchedUsers.length; j++) {
        if (this.getUsersList[i].value === matchedUsers[j]) {
          this.getUsersList[i].selected = true;
          break;
        }
      }
    }
  }

  updateMobileMemberSelection(matchedUsers) {
    for (let i = 0; i < this.teamMembers.length; i++) {
      for (let j = 0; j < matchedUsers.length; j++) {
        if (this.teamMembers[i].userId === matchedUsers[j]) {
          this.teamMembers[i].selected = true;
          break;
        }
      }
    }
  }

  uncheckAllMembers() {
    this.getUsersList?.forEach(member => {
      member.selected = false; // Set each checkbox as unchecked
    });
  }

  uncheckAllMobileMembers() {
    this.teamMembers?.forEach(member => {
      member.selected = false; // Set each checkbox as unchecked
    });
  }

  applyTeamMemberFilter() {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      this.filteredTeamMembersList = [...this.teamMembers];
      return;
    }

    this.filteredTeamMembersList = this.teamMembers.filter((member) => {
      const memberName = (
        member.name ||
        `${member.firstName || ''} ${member.lastName || ''}`
      ).trim().toLowerCase();
      const teamName = (member.teamName || this.selectedLabel || '').toLowerCase();

      return memberName.includes(term) || teamName.includes(term);
    });
  }

  filteredTeamMembers() {
    return this.filteredTeamMembersList;
  }

  filterGetUsersList() {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      this.filterdUserList = [...this.getUsersList];
      return;
    }

    this.filterdUserList = this.getUsersList.filter(member =>
      (member.label || '').toLowerCase().includes(term)
    );
  }

  onRowAddShift(selectedAddData) {
    this.manageOpenShiftsService.setData(selectedAddData);
    // this.selectedAddDataEmmiter.emit(0);
    sessionStorage.setItem('selectedScheduleId', selectedAddData.id);
    if (selectedAddData.teamList[0] !== undefined && !this.loginTypeisWeb) {
      sessionStorage.setItem('selectedAddData', selectedAddData.teamList[0] ? selectedAddData.teamList[0].teamId : '');
    } else {
      sessionStorage.setItem('selectedAddData', '');

    }
    sessionStorage.setItem('weeklyAllocation', JSON.stringify(selectedAddData.weeklyAllocation));
    sessionStorage.setItem('teamNames', selectedAddData.teamNames);
    sessionStorage.setItem('endTimeStr', selectedAddData.endTimeStr);
    sessionStorage.setItem('startTimeStr', selectedAddData.startTimeStr);
    sessionStorage.setItem('endDateTimeStr', selectedAddData.endDateTimeStr);
    sessionStorage.setItem('startDateTimeStr', selectedAddData.startDateTimeStr);
    sessionStorage.setItem('userType', selectedAddData.userType);
    sessionStorage.setItem('shiftSchedule', selectedAddData.shiftSchedule);
    sessionStorage.setItem('selectedProviderId', selectedAddData.providerId);
    sessionStorage.setItem('shiftPlanUsers', JSON.stringify(selectedAddData.shiftPlanUsers));
    sessionStorage.setItem('shiftSchedule', selectedAddData.shiftSchedule);



    if (selectedAddData.userType === '20') {
        this.router.navigate(['/manage-shift/add-shift-planning']);
    } else {
      this.router.navigate(['/hc-providers/edit-teams'], {
        queryParams: { id: selectedAddData.teamList[0].teamId, providerId: selectedAddData.providerId }
      });
      // this.router.navigate(['/edit-teams?id=817080475478555316&providerId=814556996669323356'])
    }
  }

  onHideDialog() {
    this.showDialog = false;
  }
  setAdjustValue() {
    this.updateType = 10;
    this.addShift();

  }

  setOverrideValue() {
    this.updateType = 20;
    this.addShift();
  }

  addShift() {
    const dataModel = this.getFormData();
      if (this.currentRowSelectedId) {
        this.manageOpenShiftsService.updateShiftPlanning(this.currentRowSelectedId, dataModel).subscribe(results => {
          this.isEditEnable = false;
          this.showDialog = false;
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          // this.getShiftData();
          this.disableProvider ? this.getFilterdData() : this.getShiftData();
          this.uncheckAllMembers();
          this.uncheckAllMobileMembers();
        }, (error) => {
          this.dt.editingRowKeys = { [this.selectedRowData.id]: true };
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
      } else {
        this.manageOpenShiftsService.addShiftPlanning(dataModel).subscribe(results => {
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.isEditEnable = false;
          this.showDialog = false;
          this.groupLimit = this.groupLimit + 1;
          // this.getShiftData();
          this.disableProvider ? this.getFilterdData() : this.getShiftData();
          this.shiftButtonDisabled = false;
          this.uncheckAllMembers();
          this.uncheckAllMobileMembers();
          this.disableDates = false;
        }, (error) => {
          this.dt.editingRowKeys = { [this.selectedRowData.id]: true };
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
      }
  }

  onRowEditSave(selectedRowData, dt) {

    this.resetFormData();
    this.setFormData(selectedRowData);
    this.validateForm(selectedRowData);
    if (!this.formRequiredStatus) {
      dt.editingRowKeys = { [selectedRowData.id]: true };
      this.shiftButtonDisabled = true;
    } else {
      this.selectedRowData = selectedRowData;
      this.dt = dt;
      dt.editingRowKeys = { [selectedRowData.id]: true };
      this.showDialog = true;

      /*
      const dataModel = this.getFormData();
      console.log(dataModel);
      if (this.currentRowSelectedId) {
        this.manageOpenShiftsService.updateShiftPlanning(this.currentRowSelectedId, dataModel).subscribe(results => {
          this.isEditEnable = false;
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.getShiftData();
          this.isBulkScheduleDisabled = false;
        }, (error) => {
          dt.editingRowKeys = { [selectedRowData.id]: true };
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
      } else {
        this.manageOpenShiftsService.addShiftPlanning(dataModel).subscribe(results => {
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.isEditEnable = false;
          this.groupLimit = this.groupLimit + 1;
          this.getShiftData();
          this.isBulkScheduleDisabled = false;
          this.shiftButtonDisabled = false;
        }, (error) => {
          dt.editingRowKeys = { [selectedRowData.id]: true };
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
      }*/
    }

  }

  deleteRow(i, data) {
    this.isBulkScheduleDisabled = false;
    this.isEditEnable = false;
    this.shiftAllData.splice(i, 1);
    this.shiftButtonDisabled = false;
    this.uncheckAllMembers();
    this.uncheckAllMobileMembers();
    this.disableDates = false;
  }

  onRowEditCancel(selectedCancelData, i) {
    if (selectedCancelData.id) {
      this.deleteConfirmation(selectedCancelData.id, selectedCancelData.userType);
    }
  }

  deleteConfirmation(shiftId, userType) {
    const data = {
      'userType': userType
    };
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this shift?',
      accept: () => {
        this.manageOpenShiftsService.deleteShiftPlanning(shiftId, data).subscribe(results => {
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          // this.getShiftData();
          this.disableProvider ? this.getFilterdData() : this.getShiftData();
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
      }
    });
  }

  getTeam(providerId) {
    this.manageOpenShiftsService.getTeam(providerId).subscribe((result) => {
      if (this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.value) {
        this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.forEach(e => {
          result = result.filter(ele => ele.id !== e.teamId);
        });
      }
     // this.teamList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
      for (let i = 0; i < result.length; i++) {
        this.teamList.push({ label: result[i].teamName, value: result[i].id });
      }
      this.chosenTeam = '';
    }, (error) => {
    });
  }

  addShiftBtn() {
    this.isEditEnable = true;
    this.shiftButtonDisabled = true;
    this.currentRowSelectedId = '';
    if (this.dataTable) {
      this.dataTable.first = 0;
    }
  }

  setFormData(selectedRowData) {
    this.shiftButtonDisabled = false;
    this.userScheduleId = [];
    for (let i = 0; i < this.getUsersList.length; i++) {
      if (selectedRowData.shiftPlanUsers) {
        for (let j = 0; j < selectedRowData.shiftPlanUsers.length; j++) {
          if (this.getUsersList[i].value === selectedRowData.shiftPlanUsers[j]) {
            this.userScheduleId.push({
              'userId': this.getUsersList[i].value
            });
          }
        }
      }
    }
    const selectedTeam = { 'teamId': selectedRowData.selectedTeamList };
    this.teamListIds = [selectedTeam];
    let allocationList = '';
    for (let k = 0; k < selectedRowData.weeklyAllocation.length; k++) {
      if (selectedRowData.weeklyAllocation[k].isMandatory === true) {
        allocationList += selectedRowData.weeklyAllocation[k].key + ',';
      }
    }
    this.allocationListStr = allocationList.replace(/,\s*$/, '');
    this.shiftScheduleValue = selectedRowData.shiftSchedule;
    if (selectedRowData.startTimeStr.length > 8 || selectedRowData.startTimeStr.length === undefined) {
      this.shiftStartTime = moment(selectedRowData.startTimeStr).format('hh:mm A');
    } else {
      this.shiftStartTime = selectedRowData.startTimeStr;
    }
    if (selectedRowData.endTimeStr.length > 8 || selectedRowData.endTimeStr.length === undefined) {
      this.shiftEndTime = moment(selectedRowData.endTimeStr).format('hh:mm A');
    } else {
      this.shiftEndTime = selectedRowData.endTimeStr;
    }
    const startDate = new Date();
    this.startDateTimeStr = moment(selectedRowData.startDateTimeStr).format('MM/DD/YYYY') + ' ' + '12:00 AM';

    if (selectedRowData.endDate === 'custom') {
      this.endDateTimeStr = moment(selectedRowData.endDateTimeStr).format('MM/DD/YYYY') + ' ' + '11:59 PM';
    } else {
      this.endDateTimeStr = -1;
    }
  }

  onStartDateClick(itemsData) {
    if (itemsData.startDateTimeStr) {
      const formattedStartDate = moment(itemsData.startDateTimeStr).format('MM/DD/YYYY') + ' 12:00 AM';
      const selectedStartDate = moment(formattedStartDate, 'MM/DD/YYYY hh:mm A').toDate();
      this.maxDate = selectedStartDate.getTime() >= this.minDate.getTime()
        ? selectedStartDate
        : new Date(this.minDate);
    } else {
      this.maxDate = new Date(this.minDate);
    }
  }

  resetFormData() {
    this.allocationListStr = '';
    this.shiftScheduleValue = '';
    this.shiftStartTime = '';
    this.shiftEndTime = '';
    this.startDateTimeStr = '';
    this.endDateTimeStr = '';
    this.teamListIds = [];
  }

  getFormData() {

    if (this.loginTypeisWeb) {
      this.loginTypes = 20;
    } else {
      this.loginTypes = 10;
    }
    const requestFormModel: any = {
      'startTimeStr': this.shiftStartTime,
      'endTimeStr': this.shiftEndTime,
      'startDateTimeStr': this.startDateTimeStr,
      'endDateTimeStr': this.endDateTimeStr,
      'allocations': this.allocationListStr,
      'shiftSchedule': this.shiftScheduleValue,
      // 'shiftPlanUsers': this.loginTypes === 20 ? this.userScheduleId : [],
      'shiftPlanUsers': this.shiftPlanUsers,
      'teamList': this.loginTypes === 10 ? this.teamListIds : [],
      'userType': this.loginTypes,
      'updateType': this.updateType,
      'providerId': this.provider,
    };
    return requestFormModel;
  }

  validateForm(selectedRowData) {
    let weeklySelectedCount = 0;
    let weeklyAllocationFormStatus = true;
    let shiftScheduleFormStatus = true;
    let startTimeFormStatus = true;
    let endTimeFormStatus = true;
    let startEndTimeValidationStatus = true;
    let endDateFormStatus = true;
    let teamlistFormStatus = true;
    let customDateFormStatus = true;
    let userTypelistFormStatus = true;
    const selectedUserListStatus = true;
    const shiftScheduleEmpty = selectedRowData.shiftSchedule.replace(/ +/g, ' ');

    const d = new Date();
    const dateValue = moment(d).format('MM/DD/YYYY');
    const startValue = new Date(dateValue + ' ' + this.shiftStartTime);
    const endValue = new Date(dateValue + ' ' + this.shiftEndTime);
    const startTimeMillis = startValue.getTime();
    const endTimeMillis = endValue.getTime();

    for (let k = 0; k < selectedRowData.weeklyAllocation.length; k++) {
      if (selectedRowData.weeklyAllocation[k].isMandatory === true) {
        weeklySelectedCount = weeklySelectedCount + 1;
      }
    }
    if (weeklySelectedCount === 0) {
      weeklyAllocationFormStatus = false;
      this.uiService.showMessage('Select weekly allocation', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (shiftScheduleEmpty.trim() === '' && weeklyAllocationFormStatus) {
      shiftScheduleFormStatus = false;
      this.uiService.showMessage('Shift name is required', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (selectedRowData.startTimeStr === '' && weeklyAllocationFormStatus && shiftScheduleFormStatus) {
      startTimeFormStatus = false;
      this.uiService.showMessage('Start time required', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (selectedRowData.endTimeStr === '' && weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus) {
      endTimeFormStatus = false;
      this.uiService.showMessage('End time required', AppSettings.MESSAGE_TYPES.ERROR);
    }
     if ((weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus) &&
     (startTimeMillis === endTimeMillis)) {
       startEndTimeValidationStatus = false;
       this.uiService.showMessage('End time should be greater than Start time', AppSettings.MESSAGE_TYPES.ERROR);
     }
    if (selectedRowData.endDate === '' && weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus &&
      endTimeFormStatus && startEndTimeValidationStatus) {
      endDateFormStatus = false;
      this.uiService.showMessage('Ends on required', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (selectedRowData.endDateTimeStr === '' && selectedRowData.endDate === 'custom' && weeklyAllocationFormStatus &&
      shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus && startEndTimeValidationStatus && endDateFormStatus) {
      customDateFormStatus = false;
      this.uiService.showMessage('Custom date required', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (selectedRowData.startDateTimeStr === undefined && selectedRowData.endDate === 'never') {
      userTypelistFormStatus = false;
      this.uiService.showMessage('Start date required', AppSettings.MESSAGE_TYPES.ERROR);
    }

    if ((selectedRowData.userType === undefined || selectedRowData.userType === '') &&
      weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus &&
      startEndTimeValidationStatus && endDateFormStatus && customDateFormStatus) {
      userTypelistFormStatus = false;
      this.uiService.showMessage('User Type required', AppSettings.MESSAGE_TYPES.ERROR);
    }
    if (((selectedRowData.selectedTeamList === '' || selectedRowData.selectedTeamList === undefined)
      && selectedRowData.userType === '10')
      && weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus
      && endTimeFormStatus && startEndTimeValidationStatus && endDateFormStatus
      && customDateFormStatus && userTypelistFormStatus) {
      teamlistFormStatus = false;
      this.uiService.showMessage('Team required', AppSettings.MESSAGE_TYPES.ERROR);
    }

    if (((this.provider === '' || this.provider === undefined)  && selectedRowData.userType === '10') &&
      weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus &&
      startEndTimeValidationStatus && endDateFormStatus && customDateFormStatus && userTypelistFormStatus) {
      teamlistFormStatus = false;
      this.uiService.showMessage('Provider required', AppSettings.MESSAGE_TYPES.ERROR);
    }

    if ((this.shiftPlanUsers.length === 0 &&  selectedRowData.userType === '20') &&
    weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus &&
    startEndTimeValidationStatus && endDateFormStatus && customDateFormStatus && userTypelistFormStatus) {
    teamlistFormStatus = false;
    this.uiService.showMessage('Team member required', AppSettings.MESSAGE_TYPES.ERROR);
  }

    /*if (((selectedRowData.shiftPlanUsers === '' || selectedRowData.shiftPlanUsers === undefined) && selectedRowData.userType === '20') &&
      weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus && endTimeFormStatus &&
      startEndTimeValidationStatus && endDateFormStatus && customDateFormStatus && userTypelistFormStatus) {

      selectedUserListStatus = false;

      this.uiService.showMessage('users required', AppSettings.MESSAGE_TYPES.ERROR);
    }*/
    if (weeklyAllocationFormStatus && shiftScheduleFormStatus && startTimeFormStatus
      && endTimeFormStatus && startEndTimeValidationStatus && endDateFormStatus
      && customDateFormStatus && userTypelistFormStatus && teamlistFormStatus
      && selectedUserListStatus) {
      this.formRequiredStatus = true;
    } else {
      this.formRequiredStatus = false;
    }
  }

  changeFilter(event) {
    this.endsonFilterValue = moment(event).format('MM/DD/YYYY');
    this.getFilterdData();
  }

  onEndsOnFilter(event, dt) {
      if (event.value === 'custom') {
        this.showCustomDatePicker = true;
      }
      if (event.value === 'never') {
        this.showCustomDatePicker = false;
        this.customDate = '';
        this.endsonFilterValue = '-1';
        this.getFilterdData();
      }
      if (event.value === '') {
        this.showCustomDatePicker = false;
        this.endsonFilterValue = '';
        this.customDate = '';
        this.getFilterdData();
      }
  }

  onResetFilter(dt) {
    if (this.filterSavedFlag) {
      this.manageOpenShiftsService.resetFilter(this.loginUserId, 'SHIFT_PLANNING_FILTER').subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.filterSavedFlag = false;
        localStorage.removeItem('shiftPlanningFilterPresent');
        this.storageService.removeItem(AppSettings.FILTER_DETAILS_PANNING);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });
    }
    this.searchData = '';
    this.endsonFilter = '';
    this.showCustomDatePicker = false;
    if (!this.disableProvider) {
      this.providerIdForFilter = '';
    } else {
      this.ensureProviderIdForRole();
    }
    this.selectedServiceRegionIds = [];
    this.loadServiceRegions();
    // dt.filter(this.endsonFilter, 'endDate', 'equals');
    dt.editingRowKeys = { ['']: false };
    if (this.shiftButtonDisabled) {
      this.shiftAllData.splice(0, 1);
      this.shiftButtonDisabled = false;
    }
    dt.filterGlobal('', 'contains');
    // this.getShiftData();
    this.disableProvider ? this.getFilterdData() : this.getShiftData();
  }

  // paginate(event) {
  //   this.shiftButtonDisabled = false;
  //   this.shiftAllData = [];
  //   this.groupLimit = event.rows;
  //   this.groupOffset = event.first;
  //   this.manageOpenShiftsService.getShiftPlanningData(this.groupLimit,this.groupOffset).subscribe(response => {
  //   this.shiftAllData = [...this.shiftAllData, ...response.data];
  //   for (let i = 0; i < this.shiftAllData.length; i++) {
  //     let text = this.shiftAllData[i].allocations;
  //     Object.assign(this.shiftAllData[i], {
  //       "weeklyAllocation": [
  //         { key: "1", displayValue: "S", isMandatory: text.includes("1") },
  //         { key: "2", displayValue: "M", isMandatory: text.includes("2") },
  //         { key: "3", displayValue: "T", isMandatory: text.includes("3") },
  //         { key: "4", displayValue: "W", isMandatory: text.includes("4") },
  //         { key: "5", displayValue: "T", isMandatory: text.includes("5") },
  //         { key: "6", displayValue: "F", isMandatory: text.includes("6") },
  //         { key: "7", displayValue: "S", isMandatory: text.includes("7") }
  //       ]
  //     },);
  //     const teamListAllId = [];
  //     for (let j = 0; j < this.shiftAllData[i].teamList.length; j++) {
  //       teamListAllId.push(this.shiftAllData[i].teamList[j].teamId);
  //     }
  //     Object.assign(this.shiftAllData[i], { "selectedTeamList": teamListAllId });
  //   }
  //   });

  // }

  cancelEditedRow(data, index) {
    this.isBulkScheduleDisabled = false;
    this.isEditEnable = false;
    this.products[index] = this.clonedProducts[data.id];
    delete this.products[data.id];
    this.shiftButtonDisabled = false;
    this.uncheckAllMembers();
    this.uncheckAllMobileMembers();
  }

  // showPermanentMembers(event, permanentTeamMembers, targetIcon) {
  //   this.currentPermanentMembers = permanentTeamMembers;
  //   this.op.toggle(event, targetIcon);
  // }

  // showPermanentMembers(event, permanentTeamMembers, targetIcon) {
  //   this.currentPermanentMembers = permanentTeamMembers;
  //   this.op.toggle(event, targetIcon);
  // }

  getTime(date: any, index) {
    if (date !== '') {
      const hour = moment(date).format('hh:mm A').split(':');
      const time = this.commonBindingDataService.timeAdjustment(hour);
     // this.shiftAllData[index].startTimeStr = new Date(`1970-01-01 ${time}`)
      this.checkStartTime = date;
      console.log(date);
    }
  }

  getEndTime(date: any, itemsData, index) {
    if (date !== '') {
      const hour1 = moment(date).format('hh:mm A');
      const hour = moment(date).format('hh:mm A').split(':');
      if (hour1 !== '11:59 PM') {
        const time = this.commonBindingDataService.timeAdjustment(hour);
       // this.shiftAllData[index].endTimeStr = new Date(`1970-01-01 ${time}`)
      }
      /*const hour1start = moment(this.checkStartTime).format('hh:mm A');
      if(this.checkStartTime && hour1start===hour1){
        this.uiService.showMessage('End Time cannot be same as start time.', AppSettings.MESSAGE_TYPES.ERROR);
        itemsData.endTimeStr='';
      }  */
    }
  }
  getLoginTypes(tagsData: any) {
    const loginTypes = tagsData && tagsData.open_shift_user_type ? tagsData.open_shift_user_type : [];
    if (this.disableProvider) {
      this.userList = [];
      loginTypes.forEach(element => {
        if (element.tagValue === 'Mobile App') {
           this.userList.push({ label: element.tagValue, value: element.tagId });
        }
      });
    } else {
      this.userList = [];
      this.userList.push({ label: this.commonService.getLabel('Select'), value: '' });
      loginTypes.forEach(element => {
        this.userList.push({ label: element.tagValue, value: element.tagId });
      });
    }
    if (!this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.MANAGE_SHIFT)?.value) {
      this.userList.pop();
    }
    if (this.organizationLevelDispatch) {
      this.userList.splice(1, 1);
    }
  }

  loginType(data, event) {
    this.loginTypeisWeb = event.value === '20' ? true : false;
    if (this.loginTypeisWeb) {
      data.selectedTeamList = '';
      data.provider = '';
      this.teamMembers = [];
      this.filteredTeamMembersList = [];
      this.searchTerm = '';
      this.showteamMembers = false;
      this.provider = '';
      this.chosenTeam = '';
    }
    this.shiftPlanUsers = [];
    this.uncheckAllMembers();
    this.uncheckAllMobileMembers();
  }

  getUsersListData() {
    if (this.disableProvider) {
      return;
    }
    this.manageOpenShiftsService.getUsers().subscribe(results => {
      for (let i = 0; i < results.length; i++) {
        this.getUsersList.push({ label: results[i].firstName + ' ' + results[i].lastName, value: results[i].id });
      }
    }, (error: any) => {
      // console.error('While Fetching error in getDispatchServiceTypes', error.toString());
    });
  }

  saveFilter() {
    const filterObj = {
      'endsonFilter': this.endsonFilterValue,
      'providerId': this.providerIdForFilter,
      'serviceRegionIds': this.selectedServiceRegionIds
    };
    const filterModel: any = {
      'userId': this.loginUserId,
      'filterType': 'SHIFT_PLANNING_FILTER',
      'filterData': filterObj
    };

    this.manageOpenShiftsService.teamMemberSaveFilter(filterModel).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.filterSavedFlag = true;
      localStorage.setItem('shiftPlanningFilterPresent', JSON.stringify(filterModel));
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilter() {
    const type = 'SHIFT_PLANNING_FILTER';
    this.manageOpenShiftsService.shiftPlanGetFilter(this.loginUserId, type).subscribe(results => {
      this.FilterDataFlag = results.filterData;
      if (results.filterData !== null && results.filterData !== undefined) {
        const filterDataResults = JSON.parse(results.filterData);
        this.filterSavedFlag = true;
        if (filterDataResults?.endsonFilter && filterDataResults?.endsonFilter === '-1') {
          this.endsonFilter = 'never';
          this.endsonFilterValue = '-1';
        }
        if (filterDataResults?.endsonFilter && filterDataResults?.endsonFilter !== '-1') {
          this.endsonFilter = 'custom';
          this.endsonFilterValue = filterDataResults?.endsonFilter;
          this.customDate = filterDataResults?.endsonFilter;
          this.showCustomDatePicker = true;
        }
        if (filterDataResults?.endsonFilter === '') {
          this.endsonFilter = 'all';
          this.endsonFilterValue = '';
        }
        if (filterDataResults?.providerId && !this.disableProvider) {
          this.providerIdForFilter = filterDataResults?.providerId;
        }
        if (filterDataResults?.serviceRegionIds) {
          this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
        }
        this.ensureProviderIdForRole();
        this.loadServiceRegions(filterDataResults?.serviceRegionIds, true);
        this.getFilterdData();
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilterLocal(results) {
    if (results !== null && results !== undefined) {
      const filterDataResults = results;
      this.filterSavedFlag = true;
      if (filterDataResults?.endsonFilter && filterDataResults?.endsonFilter === '-1') {
        this.endsonFilter = 'never';
      }
      if (filterDataResults?.endsonFilter && filterDataResults?.endsonFilter !== '-1') {
        this.endsonFilter = 'custom';
        this.endsonFilterValue = filterDataResults?.endsonFilter;
        this.customDate = filterDataResults?.endsonFilter;
        this.showCustomDatePicker = true;
      }
      if (filterDataResults?.endsonFilter === '') {

        this.endsonFilter = 'all';
        this.endsonFilterValue = '';
      }
      if (filterDataResults?.providerId && !this.disableProvider) {
        this.providerIdForFilter = filterDataResults?.providerId;
      }
      if (filterDataResults?.serviceRegionIds) {
        this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
      }
      this.ensureProviderIdForRole();
      this.loadServiceRegions(filterDataResults?.serviceRegionIds);
      this.getFilterdData();
    }
  }

  private applyProviderRoleScope() {
    const roleId = this.storageService.getItem<number>(AppSettings.USER_ROLE_ID);
    if (roleId === AppSettings.PROVIDER_ROLE_ID || roleId === 11) {
      this.disableProvider = true;
      this.provider = this.loginUserId;
      this.providerIdForFilter = this.loginUserId;
    }
  }

  private ensureProviderIdForRole() {
    if (this.disableProvider && this.loginUserId) {
      this.provider = this.loginUserId;
      this.providerIdForFilter = this.loginUserId;
    }
  }
}
